// extracted by mini-css-extract-plugin
export default {"search-box":"W_gf","search-box__input":"W_gg form-control","search-box__icon":"W_gh ml-2"};